import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Map, BookOpen, Tool, Home, ExternalLink } from "react-feather";
import { getApiBase } from "../../helpers/apiBase";

/**
 * Главные разделы платформы в шапке — с иконками и подписями.
 *
 * Максим 22.08.2026: «самые важные разделы, по которым чаще всего хотят
 * перейти». Голых иконок мало — по ним не считывается, куда ведёт, поэтому
 * рядом стоит название.
 *
 * «Старая админка» — внешняя ссылка на hypercube, открывается в новом окне.
 */

const PUBLIC = process.env.PUBLIC_URL || "";
const OLD_ADMIN_URL = "https://hypercube.fairyland.world";

const SECTIONS = [
  /* «Главная» переехала сюда из бокового меню 22.08.2026: там она занимала
     место, нужное списку проектов, а в шапке видна с любой страницы. */
  { key: "home", title: "Главная", to: `${PUBLIC}/home`, Icon: Home },
  { key: "worlds", title: "Миры", to: `${PUBLIC}/location-list`, Icon: Map, counter: true },
  { key: "knowledge", title: "Книга Знаний", to: `${PUBLIC}/knowledge`, Icon: BookOpen },
  { key: "workshop", title: "Мастерская", to: `${PUBLIC}/workshop`, Icon: Tool },
  {
    key: "old-admin",
    title: "Старая админка",
    href: OLD_ADMIN_URL,
    Icon: ExternalLink,
    external: true,
  },
];

const TopSections = () => {
  const [total, setTotal] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    let alive = true;
    const base = getApiBase();
    if (!base) return undefined;

    const token = localStorage.getItem("token");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    fetch(`${base}/v1/cpai/location-total`, {
      method: "POST",
      headers,
      body: JSON.stringify({}),
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!alive || !data) return;
        const value = Number(data.total);
        if (Number.isFinite(value) && value > 0) setTotal(value);
      })
      // Счётчик — украшение: не пришёл, значит показываем пункт без цифры.
      .catch(() => {});

    return () => {
      alive = false;
    };
  }, []);

  return (
    <nav className="fw-top-sections col-auto">
      {SECTIONS.map(({ key, title, to, href, Icon, counter, external }) =>
        external ? (
          <a
            key={key}
            href={href}
            className="fw-top-section"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon />
            <span>{title}</span>
          </a>
        ) : (
          <Link
            key={key}
            to={to}
            className={`fw-top-section${pathname.startsWith(to) ? " active" : ""}`}
          >
            <Icon />
            <span>{title}</span>
            {counter && total !== null && <b>{total}</b>}
          </Link>
        )
      )}
    </nav>
  );
};

export default TopSections;
